import React, { useState } from "react";
import { resetPassword } from "aws-amplify/auth";
import "./AdminLogin.css";

const ADMIN_EMAIL = "argencisupdates@gmail.com";

export default function ForgotPassword() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSend = async () => {
    setError("");

    try {
      await resetPassword({ username: ADMIN_EMAIL });
      setSent(true);
    } catch (err) {
      console.log(err);
      setError("Failed to send reset code. Try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="glass-card login-card">
        <h2 className="login-title">Reset Password</h2>

        {!sent ? (
          <>
            <p style={{ marginBottom: "10px" }}>
              Reset link will be sent to:
            </p>

            <input
              type="email"
              className="login-input"
              value={ADMIN_EMAIL}
              disabled
            />

            <button className="login-btn" onClick={handleSend}>
              Send Reset Code
            </button>

            {error && <p className="login-error">{error}</p>}
          </>
        ) : (
          <>
            <p className="login-success">
              Reset code sent! Check your email.
            </p>

            <button
              className="login-btn"
              onClick={() => (window.location.href = "/admin/reset-password")}
            >
              Enter Code
            </button>
          </>
        )}
      </div>
    </div>
  );
}
